package co.maytes.standupbot.dashboard.features.roster

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.lib.api.ApiClient
import co.maytes.standupbot.dashboard.lib.api.ApiError
import co.maytes.standupbot.dashboard.lib.api.Result
import co.maytes.standupbot.dashboard.stores.rememberApiClient
import co.maytes.standupbot.shared.dto.integration.LinearUserDto

sealed interface LinearUsersState {
    data object Idle : LinearUsersState

    data object Loading : LinearUsersState

    data class Ready(val users: List<LinearUserDto>) : LinearUsersState

    data object NotConnected : LinearUsersState

    data class Failed(val message: String) : LinearUsersState
}

class LinearUsersStore(private val api: ApiClient) {
    var state: LinearUsersState by mutableStateOf(LinearUsersState.Idle)
        private set

    suspend fun loadOnce(workspaceId: String) {
        if (state is LinearUsersState.Ready || state is LinearUsersState.Loading) return
        reload(workspaceId)
    }

    suspend fun reload(workspaceId: String) {
        state = LinearUsersState.Loading
        state =
            when (val result = api.get<List<LinearUserDto>>("/api/v1/workspaces/$workspaceId/integrations/linear/users")) {
                is Result.Ok -> LinearUsersState.Ready(result.value)
                is Result.Err -> {
                    val error = result.error
                    if (error is ApiError.Http && error.code == "linear-not-connected") {
                        LinearUsersState.NotConnected
                    } else {
                        LinearUsersState.Failed(error.displayMessage)
                    }
                }
            }
    }
}

@Composable
fun rememberLinearUsersStore(): LinearUsersStore {
    val api = rememberApiClient()
    return remember(api) { LinearUsersStore(api) }
}
